// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-rte-bold {
  font-weight: bold;
}

.fi-rte-italic {
  font-style: italic;
}

.fi-rte-underline {
  text-decoration: underline;
}

.fi-rte-link {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

.fi-rte-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.editor-link {
  color: rgb(33, 111, 219);
  text-decoration: none;
}

.link-editor-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 99;
  cursor: pointer;
}

.link-editor {
  position: absolute;
  z-index: 100;
  top: -10000px;
  left: -10000px;
  margin-top: -6px;
  max-width: 350px;
  width: 100%;
  opacity: 0;
  background-color: #fff;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  transition: opacity 0.5s;
}

.link-editor .link-input {
  display: block;
  width: calc(100% - 45px);
  box-sizing: border-box;
  margin: 8px 12px;
  padding: 8px 12px;
  border-radius: 15px;
  background-color: #eee;
  font-size: 15px;
  color: rgb(5, 5, 5);
  border: 0;
  outline: 0;
  position: relative;
  font-family: inherit;
}

.link-editor div.link-edit {
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  vertical-align: -0.25em;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.link-editor .link-edit-icon {
  position: absolute; 
  right: 0; 
  top: 50%;
   transform: translateY(-50%); 
  width: 35px; 
 height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}

.link-editor .link-input a {
  color: rgb(33, 111, 219);
  text-decoration: none;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 30px;
  text-overflow: ellipsis;
}

.link-editor .link-input a:hover {
  text-decoration: underline;
}

.link-editor .button {
  width: 20px;
  height: 20px;
  display: inline-block;
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 2px;
}

.link-editor .button.hovered {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-color: #eee;
}

.link-editor .button i,
.actions i {
  background-size: contain;
  display: inline-block;
  height: 20px;
  width: 20px;
  vertical-align: -0.25em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/rich-text-editor/theme/theme.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;GACP,2BAA2B;EAC5B,WAAW;CACZ,YAAY;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB","sourcesContent":[".fi-rte-bold {\n  font-weight: bold;\n}\n\n.fi-rte-italic {\n  font-style: italic;\n}\n\n.fi-rte-underline {\n  text-decoration: underline;\n}\n\n.fi-rte-link {\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.fi-rte-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.editor-link {\n  color: rgb(33, 111, 219);\n  text-decoration: none;\n}\n\n.link-editor-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.1);\n  z-index: 99;\n  cursor: pointer;\n}\n\n.link-editor {\n  position: absolute;\n  z-index: 100;\n  top: -10000px;\n  left: -10000px;\n  margin-top: -6px;\n  max-width: 350px;\n  width: 100%;\n  opacity: 0;\n  background-color: #fff;\n  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  transition: opacity 0.5s;\n}\n\n.link-editor .link-input {\n  display: block;\n  width: calc(100% - 45px);\n  box-sizing: border-box;\n  margin: 8px 12px;\n  padding: 8px 12px;\n  border-radius: 15px;\n  background-color: #eee;\n  font-size: 15px;\n  color: rgb(5, 5, 5);\n  border: 0;\n  outline: 0;\n  position: relative;\n  font-family: inherit;\n}\n\n.link-editor div.link-edit {\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  vertical-align: -0.25em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.link-editor .link-edit-icon {\n  position: absolute; \n  right: 0; \n  top: 50%;\n   transform: translateY(-50%); \n  width: 35px; \n height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.link-editor .link-input a {\n  color: rgb(33, 111, 219);\n  text-decoration: none;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 30px;\n  text-overflow: ellipsis;\n}\n\n.link-editor .link-input a:hover {\n  text-decoration: underline;\n}\n\n.link-editor .button {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  margin: 0 2px;\n}\n\n.link-editor .button.hovered {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-color: #eee;\n}\n\n.link-editor .button i,\n.actions i {\n  background-size: contain;\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  vertical-align: -0.25em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
